import { gql } from '@apollo/client';

export const ParagraphActivityPoiNearPoisFragment = gql`
  fragment ParagraphActivityPoiNearPois on ParagraphActivityPoiNearPois {
    id
    title
  }
`;
